/**
 * Base da API.
 *
 * Em produção o Express serve o build do React e as rotas /api na MESMA
 * origem, então a base é string vazia e as chamadas viram caminhos
 * relativos (`/api/quotes`). Não há CORS envolvido.
 *
 * Em desenvolvimento, defina REACT_APP_BACKEND_URL no frontend/.env
 * apontando para o servidor Express local — por exemplo:
 *
 *     REACT_APP_BACKEND_URL=http://localhost:3000
 *
 * Alternativamente, use a chave "proxy" do frontend/package.json e
 * deixe esta variável vazia.
 */
const RAW = process.env.REACT_APP_BACKEND_URL || "";

/** Origem do backend, sem barra final. Vazio = mesma origem. */
export const BACKEND_URL = RAW.replace(/\/+$/, "");

/** Prefixo das rotas da API, ex.: "" + "/api" → "/api". */
export const API = `${BACKEND_URL}/api`;

export default API;
